import { render, staticRenderFns, recyclableRender, components } from "./withdraw-success.vue?vue&type=template&id=354b87a0&scoped=true&"
var renderjs
import script from "./withdraw-success.vue?vue&type=script&lang=js&"
export * from "./withdraw-success.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-success.vue?vue&type=style&index=0&id=354b87a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b87a0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/withdraw-success/withdraw-success.vue"
export default component.exports